import { render, staticRenderFns } from "./AdicionarRemoverProdutoDialogo.vue?vue&type=template&id=577b6308&"
import script from "./AdicionarRemoverProdutoDialogo.vue?vue&type=script&lang=js&"
export * from "./AdicionarRemoverProdutoDialogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports